module.exports = __webpack_public_path__ + "img/caviarSmall.4eb2b2ec.jpg";